import React, { useEffect, useState } from "react";
import GraphView from "../../components/common/GraphView";
import { Link, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { getServices } from "../../apiServices/apiServices";
import LoadingGif from "../../assets/loading_anim.gif";
import { Card, CardBody, Collapse, IconButton } from "@material-tailwind/react";
import { FaFilter } from "react-icons/fa";
import { FILTER_GRAPH_INTERVAL } from "../../variables/constants";
import dayjs from "dayjs";

const getTodayDate = () => dayjs().format("YYYY-MM-DD");
const getCurrentTime = () => dayjs().subtract(30, "minute").format("HH:mm");

function PressureGraphView() {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterOptionOpen, setFilterOptionOpen] = useState(false);
  const [filterData, setFilterData] = useState({
    date: getTodayDate(),
    time: getCurrentTime(),
    interval: "30",
  });
  const navigate = useNavigate();
  const { branch_id } = useParams();
  const access_token =
    localStorage.getItem("gassol-super-admin-token") ||
    localStorage.getItem("gassol-admin-token") ||
    localStorage.getItem("gassol-head-branch-token") ||
    localStorage.getItem("gassol-sub-branch-token");

  // Calculate toTime based on from date/time and interval
  // const calculateToTime = () => {
  //   const { date, time, interval } = filterData;
  //   const fromDateTime = dayjs(`${date}T${time}`);

  //   // Add interval to fromDateTime
  //   return fromDateTime.add(interval, "minute").format("HH:mm");
  // };

  useEffect(() => {
    if (!access_token) {
      navigate("/sign_in");
    }

    window.scrollTo(0, 0);

    fetchChartData();
  }, [filterData]);

  const fetchChartData = async () => {
    setLoading(true);

    try {
      // const toTime = calculateToTime();

      const res = await getServices(
        `/api/list/pressure?branch_id=${branch_id}&date=${
          filterData.date
        }&fromTime=${"00:00"}&toTime=${"23:59"}&interval=0`
        // `/api/list/pressure?branch_id=${branch_id}&date=${filterData.date}`
      );

      setLoading(false);
      if (res.responseCode === 200) {
        setChartData(res.responseData?.[0]);
      } else {
        setChartData([]);
      }
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  const lineChartOptions = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      theme: "light",
      // custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      //   const data = w.config.series[seriesIndex].data[dataPointIndex];
      //   return `
      //     <div class="apexcharts-tooltip">
      //       <div class="tooltip-title">${data.x}</div>
      //       <div class="tooltip-content">
      //         <div>Sales: <strong>${data.y}</strong></div>
      //         <div>Status: ${data.support}</div>
      //       </div>
      //     </div>
      //   `;
      // },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    xaxis: {
      type: "category",
      categories: chartData.xAxis || [],
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        show: false,
        style: {
          colors: "#545353",
          fontSize: "12px",
          fontFamily: "Poppins",
        },
      },
    },
    // yaxis: {
    //   labels: {
    //     style: {
    //       colors: "#545353",
    //       fontSize: "12px",
    //       fontFamily: "Poppins",
    //     },
    //   },
    // },

    yaxis: [
      {
        title: {
          text: "Pressure",
          style: { fontFamily: "Poppins", fontSize: "14px", fontWeight: "700" },
        },
        labels: {
          formatter: function (value) {
            return value; // Show fractional values for first y-axis
          },
        },
      },
      // {
      //   opposite: true,
      //   title: {
      //     text: "Manifold Status (0: Empty, 1: Loaded, 2: Running, 3: Emptying)",
      //     style: { fontFamily: "Poppins", fontSize: "13px", fontWeight: "700" },
      //   },
      //   labels: {
      //     formatter: function (value) {
      //       return Math.round(value); // Show whole numbers for second y-axis
      //     },
      //   },
      //   tickAmount: 3,
      // },
    ],
    legend: {
      show: false,
      fontFamily: "Poppins",
    },
    grid: {
      strokeDashArray: 4,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "light",
        type: "vertical",
        shadeIntensity: 0.5,
        inverseColors: true,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [],
      },
      colors: ["#03438D", "#ffffff", "#ffffff", "#ffffff", "#ffffff"],
    },
    colors: [
      "#03438D",
      "transparent",
      "transparent",
      "transparent",
      "transparent",
    ],
  };

  const toggleFilterOpen = () => {
    setFilterOptionOpen(!filterOptionOpen);
  };

  return (
    <>
      <div className="py-4 md:py-8 max-w-[1400px] mx-auto px-3">
        <>
          <div className="flex gap-2 justify-between items-start flex-row">
            <div className="flex gap-3 sm:gap-6">
              <Link
                to={-1}
                className="flex gap-2 items-center font-semibold text-xl text-[#BDBDBD]"
              >
                <p>Graph View</p>
              </Link>
            </div>

            <div>
              <IconButton onClick={toggleFilterOpen}>
                <FaFilter />
              </IconButton>
              {filterOptionOpen && (
                <Collapse
                  open={filterOptionOpen}
                  className="absolute right-1 sm:right-10 z-20 w-fit"
                >
                  <Card className="my-4 ml-auto w-[95%] sm:w-[500px] border border-gray-400">
                    <CardBody>
                      <p className="flex items-center gap-3 text-black font-semibold text-xl mb-3">
                        <FaFilter className="text-base" />
                        Filter
                      </p>
                      <form
                        className="flex flex-col gap-4"
                        // onSubmit={handleFilterSubmit}
                      >
                        <div className="flex flex-col">
                          <label className="font-semibold">Date: </label>
                          <input
                            type="date"
                            onKeyDown={(e) => e.preventDefault()}
                            value={filterData.date}
                            onChange={(e) =>
                              setFilterData({
                                ...filterData,
                                date: e.target.value,
                              })
                            }
                            max={getTodayDate()}
                            className="bg-gray-200 px-3 py-2 rounded-md border border-gray-600 outline-none"
                          />
                        </div>

                        {/* <div className="flex flex-col">
                          <label className="font-semibold">Time: </label>
                          <input
                            type="time"
                            onKeyDown={(e) => e.preventDefault()}
                            value={filterData.time}
                            onChange={(e) =>
                              setFilterData({
                                ...filterData,
                                time: e.target.value,
                              })
                            }
                            className="bg-gray-200 px-3 py-2 rounded-md border border-gray-600 outline-none"
                          />
                        </div> */}

                        {/* <div className="flex flex-col">
                          <label className="font-semibold">Interval: </label>
                          <select
                            value={filterData.interval}
                            onChange={(e) =>
                              setFilterData({
                                ...filterData,
                                interval: e.target.value,
                              })
                            }
                            className="bg-gray-200 px-3 py-2 rounded-md border border-gray-600 outline-none"
                          >
                            {FILTER_GRAPH_INTERVAL.map((interval) => (
                              <option
                                key={interval.value}
                                value={interval.value}
                              >
                                {interval.label}
                              </option>
                            ))}
                          </select>
                        </div> */}
                      </form>
                    </CardBody>
                  </Card>
                </Collapse>
              )}
            </div>
          </div>

          <div>
            <p className="text-black font-semibold text-2xl">
              Branch: {chartData?.branch_name}
            </p>
            <p className="text-center font-semibold">
              Manifold Status (0: Empty, 1: Loaded, 2: Running, 3: Emptying)
            </p>
          </div>

          {!loading ? (
            <>
              {chartData?.chartData?.length > 0 ? (
                <div className="h-[50dvh] md:h-[100dvh] mb-9">
                  <GraphView
                    lineChartOptions={lineChartOptions}
                    chartData={chartData}
                  />
                </div>
              ) : (
                <div className="text-center h-[50vh] flex flex-col justify-center items-center">
                  <p className="font-semibold text-xl sm:text-3xl">
                    Oops! No Data Found...
                  </p>
                  <p className="text-sm mt-2 ">
                    Looks like we couldn't find any data.
                  </p>
                </div>
              )}
            </>
          ) : (
            <div className="w-full flex justify-center items-center h-[60vh]">
              <img src={LoadingGif} alt="Gassol" />
            </div>
          )}
        </>
      </div>
    </>
  );
}

export default PressureGraphView;
